import RedirectContainer from "../../../components/RedirectContainer";
import {
    Container,
    Row,
    Col,
    Button,
    Form,
    Table,
    Modal,
    InputGroup,
} from "react-bootstrap";
import Checkbox from '@material-ui/core/Checkbox';
import SidebarPanelNavigation from "../../../components/SidebarPanelNavigation";
import { BsFillGridFill } from "react-icons/bs";
import { Formik, useFormik, Form as FormFormik, Field } from "formik";
import { IoIosAddCircle } from "react-icons/io";
import { MdDelete, MdEdit } from "react-icons/md";
import { useState, useEffect } from "react";
import LoadingIndicator from "../../../components/LoadingIndicator";
import { TiInputChecked } from "react-icons/ti";
import {
    getAllReviews,
   
    deleteReview,

} from "../../../services/api";
import useNotification from "../../../contexts/notification";
import PaginationComponent from "../../../components/Pagination";

export default function Categories() {
    const [query, setQuery] = useState("");
    const [data, setData] = useState([]);
    
    const [isLoading, setIsLoading] = useState(true);
   
    const [page, setPage] = useState(1);
    
    const [selectedCategory, setSelectedCategory] = useState(null);
    const { setMessage } = useNotification();
    
    const refresh = () => {
        const error = {
            error: true,
            content: "Erro ao recarregar. Tente novamente mais tarde",
        };

        if (query) {
           /* searchCategoryType(query, page).then(
                (data) => {
                    setData(data.categories);
                },
                () => setMessage(error)
            );*/
        } else {
            getAllReviews(page).then(
                (data) => {
                    setData(data);
                },
                () => setMessage(error)
            );
        }
    };

    function handleQueryCategory(e) {
        e.preventDefault();
      /*  searchCategoryType(query, page).then((data) => {
            setData(data.categories || []);
        });*/
    }



    useEffect(() => {
        if (query.length === 0) {
            getAllReviews(page).then(
                (response) => {
                    setData(response);
                    setIsLoading(false);
                },
                () =>
                    setMessage({
                        error: true,
                        content: "Um erro ocorreu. Tente novamente mais tarde",
                    })
            );
        } else {
            setPage(1)
        }
    }, [query, page, setMessage]);

    

    return (
        <>
            <RedirectContainer role="admin">
                <Container fluid>
                    <div>
                        <SidebarPanelNavigation isAdmin />
                        <div className="content-panel">
                            {isLoading && <LoadingIndicator />}
                            {!isLoading && (
                                <>
                                    <div className="py-3">
                                        <h5 className="text-primary mb-3 mb-sm-0 mb-md-0 mb-lg-0 mb-xl-0">
                                            <BsFillGridFill className="mr-2" />
                                            Comentários
                                        </h5>
                                    </div>


                                    <Row>
                                        <Col lg={12}>

                                            <Table striped bordered hover responsive size="sm">
                                                <thead>
                                                    <tr>
                                                        <th>Comentário</th>
                                                        <th>Usuário</th>
                                                        <th>Noticia</th>
                                                        <th className="w-25">Ações</th>
                                                    </tr>
                                                </thead>
                                                {data.length === 0 && (
                                                    <h5 className="text-muted text-center my-5">
                                                        Sem resultados
                                                    </h5>
                                                )}
                                                <tbody>
                                                    {data.map((categories) => (
                                                        <tr key={categories.id} className="w-25">
                                                            <td>{categories.review}</td>
                                                            <td>{categories.user_name}</td>
                                                            <td>{categories.new_id.name}</td>
                                                            <td className="d-flex">
                                                              

                                                                <Button
                                                                    size="sm"
                                                                    onClick={() => {
                                                                        let conf = window.confirm("Esta ação deletará o cartão fidelidade.");
                                                                        if (conf) {
                                                                            deleteReview(categories).then(
                                                                                () => setMessage({
                                                                                    error: false,
                                                                                    content: "Categoria deletada com sucesso."
                                                                                }), () => setMessage({
                                                                                    error: true,
                                                                                    content: "Ocorreu um erro, tente novamente mais tarde."
                                                                                })
                                                                            )
                                                                            refresh();
                                                                        }
                                                                    }
                                                                    }
                                                                    variant="danger"
                                                                    className="text-white d-flex align-items-center"
                                                                >
                                                                    <MdDelete style={{ fontSize: "1.4em" }} />
                                                                </Button>
                                                              
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>

                                            {/* <div className="d-flex justify-content-end">
                        <Pagination>
                          <Pagination.First />
                          <Pagination.Prev />
                          <Pagination.Item active>{1}</Pagination.Item>
                          <Pagination.Item>{2}</Pagination.Item>
                          <Pagination.Item>{3}</Pagination.Item>
                          <Pagination.Next />
                          <Pagination.Last />
                        </Pagination>
                      </div> */}
                                        </Col>
                                    </Row>
                                </>
                            )}
                        </div>
                    </div>
                </Container>
            </RedirectContainer>
        </>
    );
}
